import { Col, Row } from 'antd';
import { UserName } from '../name_component/user/UserNameComponent';
import * as React from 'react';
import DateTimeHover from '../date_time_component/DateTime';
import {
	compareStrings,
	contactObjectExists,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import ForwardedDetails from './ForwardedDetails';

export default function ApprovalHierarchyUserDisplay({
	user,
	item,
	status = null,
	timestamp = null,
}) {
	const { contact, email } = user;
	const approvalForwardDetails = nullSafeGetOrElse('approvalForwardedDetails', item, []);
	const forwardDetails = approvalForwardDetails.find((forwardedUser) =>
		compareStrings(nullSafeGet('forwardedTo', forwardedUser), email)
	);
	return (
		<Row style={{ justifyContent: 'space-between', margin: '8px' }}>
			<Col>
				{contactObjectExists(contact) ? <UserName contact={contact} underline={false} /> : email}
			</Col>
			<Col>
				{status && timestamp ? (
					<Row className={'justify-end'}>
						<span>
							{status}{' '}
							<DateTimeHover
								timestamp={timestamp}
								timeZone={nullSafeGet('location.timeZoneId', item)}
							/>
						</span>
					</Row>
				) : null}
				{forwardDetails ? <ForwardedDetails details={forwardDetails} item={item} /> : null}
			</Col>
		</Row>
	);
}
